// extracted by mini-css-extract-plugin
export var body = "_3k-1";
export var bodyPadded = "_3k-2";
export var chevron = "_3k-4";
export var chevronOpen = "_3k-5";
export var header = "_3k-0";
export var icon = "_3k-3";